<template>
	<div class="detailcont" :class="[bgshow?'disable':'']" v-if="showDetail">
		<a :href="queryOrderUrl" class="dingdan" v-if="!douying">订单查询</a>
		<div class="description">
			<img :src="dataDetail.mainImg.split(',').length>1?dataDetail.mainImg.split(',')[1]:dataDetail.mainImg.split(',')[0]+'-cover.webp'"
				style="max-width:100%;">
		</div>
		<div class="zhongjian" :style="{'background':dataDetail.orderBgcolor}">
			<div class="kuancont">
				<!-- <div class="flex titlecont borderBottom">
          <div class="Ititle">套餐类型</div>
          <div class="Ivalue"> {{dataDetail.name}} | {{dataDetail.introduce}} </div>
        </div>
        <div class="tip">实名信息（运营商直发，信息安全保密）'+dataDetail.orderBgcolor+'</div> -->
				<!--<div class="zhanwei" :style="{'background':'linear-gradient(to right,'+dataDetail.orderBgcolor+', rgba(0, 0, 255, 0))'}"></div>-->
				<div class="zhanwei"></div>
				<div class="flex titlecont">
					<div class="Ititle">姓名</div>
					<div class="Ivalue"><input v-model="form.consignee" ref="consignee" placeholder="请输入姓名（已加密）" />
					</div>
				</div>
				<div class="flex titlecont ">
					<div class="Ititle">身份证号</div>
					<div class="Ivalue"><input type="text" v-model="form.idcard" ref="idcard"
							placeholder="请输入身份证号（已加密）" /></div>
				</div>
				<div class="flex titlecont">
					<div class="Ititle">联系电话</div>
					<div class="Ivalue"><input type="number" v-model="form.mobile" ref="mobile"
							placeholder="请输入联系电话，并保持畅通" /></div>
				</div>
				<!-- <div class="tip">填写配送地址</div> -->
				<div class="flex titlecont">
					<div class="Ititle">所在城市</div>
					<div class="Ivalue">
						<p class="citys" @click="getAddress">
							<input v-model="acity" ref="acity" placeholder="省市区/县" readonly />
						</p>
					</div>
				</div>
				<div class="flex titlecont">
					<div class="Ititle">详细地址</div>
					<div class="Ivalue"><input v-model="form.address" ref="address" placeholder="小区、写字楼、门牌号等"
							@input="addressInput" /></div>
				</div>
				<template v-if="dataDetail.needIdcard==1 && showCity">
					<div class="fw sfzTips">根据有关部门要求，此套餐必须上传真实身份证照片。<br><span class="red">未上传照片，订单将无效。</span></div>
					<div class="sfzCont">

						<div class="uploads">
							<div class="flex">
								<a-upload name="file" :data="canshu" list-type="picture-card" class="avatar-uploader"
									:show-upload-list="false" :action="uploadImg"
									accept="image/jpg,image/jpeg,image/png"
									:before-upload="(file) => beforeUpload(file, 'idcardFront')"
									@change="(value) => handleChange(value, 'idcardFront')">
									<img v-if="form.idcardFront" :src="form.idcardFront" alt="avatar" />
									<div v-else>
										<a-icon :type="idcardFrontloading ? 'loading' : 'plus'" />
									</div>
								</a-upload>
								<div class="uploadRight"><img src="../../assets/face.png"></div>
							</div>
							<div class="uploadTip">证件四角边缘空隙2厘米以上，手机横拍，照片清晰不模糊，无水印，无反光，无PS</div>
						</div>
						<div class="uploads">
							<div class="flex">
								<a-upload name="file" :data="canshu" list-type="picture-card" class="avatar-uploader"
									:show-upload-list="false" :action="uploadImg"
									accept="image/jpg,image/jpeg,image/png"
									:before-upload="(file) => beforeUpload(file, 'idcardBack')"
									@change="(value) => handleChange(value, 'idcardBack')">
									<img v-if="form.idcardBack" :src="form.idcardBack" alt="avatar" />
									<div v-else>
										<a-icon :type="idcardBackloading ? 'loading' : 'plus'" />
									</div>
								</a-upload>
								<div class="uploadRight"><img src="../../assets/back.png"></div>
							</div>
							<div class="uploadTip">证件四角边缘空隙2厘米以上，手机横拍，照片清晰不模糊，无水印，无反光，无PS</div>
						</div>
						<div class="uploads">
							<div class="flex">
								<a-upload name="file" :data="canshu" list-type="picture-card" class="avatar-uploader"
									:show-upload-list="false" :action="uploadImg"
									accept="image/jpg,image/jpeg,image/png"
									:before-upload="(file) => beforeUpload(file, 'bustShot')"
									@change="(value) => handleChange(value, 'bustShot')">
									<img v-if="form.bustShot" :src="form.bustShot" alt="avatar" />
									<div v-else>
										<a-icon :type="bustShotloading ? 'loading' : 'plus'" />
									</div>
								</a-upload>
								<div class="uploadRight"><img src="../../assets/head2.png"></div>
							</div>
							<div class="uploadTip">无需手持身份证，胸部以上，露出双肩，人像面部比例不低于1/3，无水印，无反光，无PS</div>
						</div>
						<p class="f16">请上传真实环境拍摄的半身照，不要上传证件照</p>
						<div class="bottomTip">
							*请填写真实身份信息，信息错误将无法发货。运营商直发，信息安全保密。
						</div>
					</div>
				</template>

				<div class="ageree" v-if="xieyiList.length>0&&!zhihuAgents.includes(form.dlid)">
					<a-checkbox v-model:checked="agreeChecked"></a-checkbox>
					我已同意
					<span v-for="item in xieyiList"
						@click="openText(item.docTitle,item.docContent)">《{{item.docTitle}}》</span>
				</div>
				<div class="submitOrder" style="padding-bottom: 10px;">
					<div class="daojishi" v-if="remainingTime">距下架仅剩<span>{{remainingTime}}</span></div>
					<a-button type="primary" @click="submitSys" style="border-radius: 5px;">提交信息</a-button>
				</div>

			</div>
		</div>
		<div class="submitOrder piaofu" v-if="piaoVibli">
			<div class="daojishi" v-if="remainingTime">距下架仅剩<span>{{remainingTime}}</span></div>
			<a-button type="primary" @click="submitSys" :disabled="isSubBtnDisabled">提交信息</a-button>
		</div>
		<div class="description">
			<img :src="dataDetail.detailImg.includes(',')?dataDetail.detailImg.split(',')[1]:dataDetail.detailImg.split(',')[0]+'-cover.webp'"
				style="max-width:100%;">
			<img :src="douyingAuthImg" style="max-width:100%;">
		</div>

		<!-- 协议内容 -->
		<a-drawer height='500px' :title="xyTitle" placement="bottom" :closable="true" :visible="xyVisible"
			@close="onClose">
			<div v-html="xyContent"></div>
		</a-drawer>
		<!-- 省市区 -->
		<div class="blackbg" v-show="bgshow">
			<div class="addkuang">
				<div class="addkuangtitle">
					<span>选择省市区</span><span class="closes" @click="close">✖</span>
				</div>
				<div class="province">
					<span @click="dataList" :class="prishow==true?'spanact':'spannom'">{{pro}}</span>
					<span @click="citys" v-show="cityspanshow==true"
						:class="cityshow==true?'spanact':'spannom'">{{cit}}</span>
					<span @click="qus" v-show="quspanshow==true" :class="qushow==true?'spanact':'spannom'">{{qu}}</span>
				</div>
				<div class="chooseadd" ref="chooseadd">
					<div ref="pro1" v-show="prishow==true" class="provinceEach" v-for="(item, index) in proList"
						@click="cityfun(item.key,item.value)">
						{{item.value}}
					</div>
					<div ref="cit2" v-show="cityshow==true" class="provinceEach" v-for="(item, index) in citList"
						@click="qufun(item.key,item.value)">
						{{item.value}}
					</div>
					<div ref="qu3" v-show="qushow==true" class="provinceEach" v-for="(item, index) in quList"
						@click="endlist(item.key,item.value)">
						{{item.value}}
					</div>
				</div>
			</div>
		</div>

		<!-- 切换卡 -->
		<div class="otherCard" v-if="otherCard">
			<div class="cardCont" v-if="cardShow">
				<div class="close2" @click="closeOther"><img src="../../assets/close2.png"></div>
				<img class="tipTop" src="../../assets/sorroy.png" />
				<template v-if="xjOther">
					<div class="cardTitle">
						<dl>
							<dt>{{othenTip}}</dt>
						</dl>
					</div>
				</template>
				<template v-else>
					<div class="cardTitle">
						<dl>
							<dt>{{ qhCardDataDetail.introduce }}</dt>
							<dd>套餐一样仅运营商不一样</dd>
						</dl>
					</div>
					<div class="cardList flex">
						<div><img :src="qhCardDataDetail.mainImg.split(',')[0]+'-cover.webp'" /></div>
						<dl>
							<dt><span>{{ qhCardDataDetail.mainTag }}</span>{{extractChinese(qhCardDataDetail.name)}}:{{ qhCardDataDetail.introduce }}
							</dt>
							<dd>{{ qhCardDataDetail.subTag }}</dd>
						</dl>
					</div>
					<div class="huos flex"><img
							src="../../assets/huo.png" />已有<span>99%</span>的用户选择{{extractChinese(qhCardDataDetail.name)}}
					</div>
					<div class="ageree" v-if="otherXieyiList.length>0&&!zhihuAgents.includes(form.dlid)">
						<a-checkbox v-model:checked="agreeChecked" class="round-checkbox"></a-checkbox>
						我已同意
						<span v-for="item in otherXieyiList"
							@click="openText(item.docTitle,item.docContent)">《{{item.docTitle}}》</span>
					</div>
					<div class="qiehuan">
						<a-button type="primary" @click="submitSys2" :disabled="isSubBtnDisabled">立即切换</a-button>
					</div>
				</template>
			</div>
			<div class="okImg" v-if="otherOk">
				<img class="zhutu" :src="dataDetail.otherTrueImg" />
				<div class="close2" @click="closeOther2"><img src="../../assets/close2.png"></div>
			</div>
		</div>

		<!-- 切换加载 -->
		<div class="qieLoad" v-if="loadingImg">
			<dl>
				<dt><img src="../../assets/loading.gif" /></dt>
			</dl>
		</div>

		<!-- 前往公众号 -->
		<div class="gzhModal" :class="showM ? 'showM' : ''">
			<div class="guang"><img src="https://cdn.viphk.anqingzhiyun.com/mpimg/guang.png-cover.webp" /></div>
			<div class="gz">
				<a :href="mpSkipLink"><img class="infos"
						src="https://cdn.viphk.anqingzhiyun.com/mpimg/gongzonghao.png-cover.webp"></a>
				<div class="guan" @click="closeGZH"><img src="../../assets/close.png" /></div>
			</div>
		</div>
	</div>
	<div class="modals" v-else-if="msgVisible">
		<div class="modalCont">{{msg}}</div>
	</div>
</template>

<script>
	import {
		getCommodity,
		submitOrder,
		getShopDetail,
		agreement,
		getAgents,
		getCity
	} from '@/api/index'
	import configPort from '@/utils/common.js'
	import formValidation from "@/utils/validator"
	import address from "@/utils/address2"

	export default {
		data() {
			return {
				remainingTime: null,
				thisTimes: null,
				loadingImg: false,
				otherCard: false,
				cardShow: false,
				otherOk: false,
				xjOther: false,
				othenTip: '',
				otherXieyiList: [],
				qhCardDataDetail: {},
				showDetail: false,
				douying: false,
				mpSkipLink: null,
				douyingAuthImg: '',
				queryOrderUrl: '',
				zhihuAgents: [],
				isSubBtnDisabled: false,
				acity: '',
				bgshow: false,
				piaoVibli: false,
				showCity: false,
				message: '',
				proList: [],
				citList: [],
				quList: [],
				// streetList:[],
				prishow: true,
				xyTitle: '',
				xyContent: '',
				xyVisible: false,
				cityshow: false,
				qushow: false,
				streetshow: false,
				cityspanshow: false,
				quspanshow: false,
				streetspanshow: false,
				pro: "请选择",
				cit: "请选择",
				qu: "请选择",
				labelCol: {
					span: 4
				},
				showM: false,
				xieyiList: [],
				wrapperCol: {
					span: 14
				},
				mobile: '',
				dataDetail: {},
				msg: '',
				msgVisible: false,
				agreeChecked: false,
				idcardFrontloading: false,
				idcardBackloading: false,
				bustShotloading: false,
				imgUrl: configPort.imgUrl,
				uploadImg: configPort.host + 'api/imgUpload',
				tipImg: require("@/assets/down.png"),
				canshu: {
					biz: 'temp'
				},
				form: {
					address: "",
					bustShot: "",
					channelId: "",
					city: "",
					clickPlatform: "",
					consignee: "",
					county: "",
					idcard: "",
					idcardBack: "",
					idcardFront: "",
					mobile: "",
					province: "",
					spuId: "",
					dlid: "",
					clickId: ""
				},
				rules: {},
				plugid: null
			}
		},
		created() {
			let {
				spid,
				qdid,
				dlid,
				douying,
				plugid,
				track_id,
				click_id
			} = this.$route.query
			this.form.spuId = spid
			this.form.channelId = qdid
			this.form.dlid = dlid
			if (track_id) {
				this.form.clickId = track_id
			}
			if (click_id) {
				this.form.clickId = click_id
			}
			this.plugid = plugid
			this.getDataDetail(spid)
			this.dataList()
			this.getShop(dlid)
			this.douying = douying ? true : false
			this.queryOrderUrl = "/reference?dlid=" + (dlid ? dlid : '')
			this.getZhihuAgents()
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.getCityAddress()
			document.addEventListener('keydown', function(event) {
				if (event.keyCode === 123) {
					event.preventDefault();
				}
			});
			document.addEventListener('contextmenu', e => e.preventDefault());
			document.querySelectorAll('img').forEach(img => {
				img.addEventListener('dragstart', e => e.preventDefault());
			});
		},
		destroyed() {
			clearInterval(this.thisTimes)
		},
		methods: {
			// 获取地址
			getCityAddress() {
				getCity().then(res => {
					if (res.data.code == 200) {
						// let {province,city,district} = res.data.result
						let {
							ipProv,
							ipCity,
							ipArea
						} = res.data.result;
						this.pro = ipProv
						this.cit = ipCity
						this.qu = ipArea
						this.acity = this.pro + " " + this.cit + " " + this.qu;
						if (ipProv != '') {
							let sheng = this.proList.filter((item => {
								return item.value.indexOf(ipProv) >= 0
							}))
							this.cityfun(sheng[0].key, sheng[0].value)
						}
						if (ipCity != '') {
							let shi = this.citList.filter((item) => {
								return item.value.indexOf(ipCity) >= 0
							})
							this.qufun(shi[0].key, shi[0].value)
						}
						let squ = this.quList.filter((item) => {
							return item.value.indexOf(ipArea) >= 0
						})
						if (squ.length > 0) {
							this.endlist(squ[0].key, squ[0].value)
						} else {
							this.endlist('', '')
						}
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			extractChinese(str) {
				const chineseRegex = /^[\u4e00-\u9fa5]+/;
				return str.match(chineseRegex)?.toString() || '';
			},
			extractNumber(str) {
				// 提取字符串末尾的数字、英文和标点符号
				const match = str.match(/[a-zA-Z0-9]+[\w.]*$/);
				return match ? match[0] : '';
			},
			// 关闭前往公众号页面
			closeGZH() {
				this.showM = false
				this.$router.push({
					path: "/order",
					query: {
						phone: this.form.mobile,
						dlid: this.form.dlid
					}
				})
			},
			// 页面滑动
			handleScroll() {
				let juTop = window.scrollY
				if (juTop > 750) {
					this.piaoVibli = true
				} else {
					this.piaoVibli = false
				}
			},
			// 知乎代理
			getZhihuAgents() {
				getAgents({
					'agentIds': '1834466519712780289'
				}).then(res => {
					if (res.data.code == 200) {
						res.data.result.forEach(item => {
							this.zhihuAgents.push(item.value)
						})
					} else {
						this.$message.error(res.data.message)
					}
				}).catch(error => {})
			},
			// 店铺信息
			getShop(dlid) {
				getShopDetail({
					dlid
				}).then(res => {
					if (res.data.code == 200) {
						let {
							logo,
							mpSkipLink
						} = res.data.result
						this.mpSkipLink = mpSkipLink
						const link = document.querySelector("link[rel~='icon']");
						link.href = logo
						const newMeta = document.createElement('meta');
						newMeta.setAttribute('name', 'description');
						newMeta.setAttribute('content', res.data.result.description);
						document.head.prepend(newMeta);
					} else {
						this.$message.error(res.data.message)
					}
				}).catch(error => {})
			},
			// 选择城市
			dataList() {
				let prolist = []
				let prov = address.province_list
				for (let key in prov) {
					prolist.push({
						value: prov[key],
						key
					})
				}
				this.proList = prolist
				this.prishow = true;
				this.cityshow = false;
				this.qushow = false;
				this.streetshow = false;
			},
			getAddress() {
				this.bgshow = true;
			},
			cityfun(e, n) {
				let jiequ = e.substring(0, 2)
				let city = address.city_list
				let citylist = []
				for (let key in city) {
					if (key.substring(0, 2) == jiequ) {
						citylist.push({
							value: city[key],
							key
						})
					}
				}
				this.pro = n;

				this.citList = citylist;
				this.cityspanshow = true;
				this.quspanshow = false;
				this.streetspanshow = false;

				this.prishow = false;
				this.cityshow = true;
				this.qushow = false;
				this.streetshow = false;
				this.cit = "请选择";
				//   this.qu="请选择";
				this.street = "请选择";
				if (this.$refs.chooseadd) {
					this.$refs.chooseadd.scrollTop = 0
				}
			},
			citys() {
				this.prishow = false;
				this.cityshow = true;
				this.qushow = false;
				this.streetshow = false;
			},
			qus() {
				this.prishow = false;
				this.cityshow = false;
				this.qushow = true;
				this.streetshow = false;
			},
			qufun(e, n) {
				let jiequ = e.substring(0, 4)
				let county = address.county_list
				let countylist = []
				for (let key in county) {
					if (key.substring(0, 4) == jiequ) {
						countylist.push({
							value: county[key],
							key
						})
					}
				}
				this.cit = n;
				this.quList = countylist;
				this.quspanshow = true;
				this.streetspanshow = false;

				this.prishow = false;
				this.cityshow = false;
				this.qushow = true;
				this.streetshow = false;
				this.qu = "请选择";
				if (this.$refs.chooseadd) {
					this.$refs.chooseadd.scrollTop = 0
				}
			},
			endlist(e, n) {
				this.qu = n;
				this.bgshow = false;
				this.acity = this.pro + " " + this.cit + " " + this.qu;
				this.form.province = this.pro
				this.form.city = this.cit
				this.form.county = this.qu
				this.showCity = true
			},

			close() {
				this.bgshow = false;
			},
			addressInput() {
				if (this.form.address.length > 0)
					this.agreeChecked = true
			},
			// 显示全图
			toggleHeight() {
				let shopImg = document.getElementById('shoppic')
				let shopHeight = shopImg.clientHeight
				if (shopHeight == 400) {
					shopImg.style.height = 'auto'
					this.tipImg = require("@/assets/up.png")
				} else {
					shopImg.style.height = '400px'
					this.tipImg = require("@/assets/down.png")
				}
			},
			// 获取当前时间
			getNowTime(updateTime, countDown) {
				var nowTime = new Date().getTime();
				var cardTime = new Date(updateTime.replace(/-/g, "/")).getTime()
				var geTime = countDown * 60 * 60 * 1000
				var chaTime = cardTime + geTime - nowTime
				if (chaTime > 0) {
					var day = 24 * 60 * 60 * 1000
					var hours = 60 * 60 * 1000
					var minutes = 60 * 1000
					var d = Math.floor((chaTime / day))
					var h = Math.floor((chaTime % day) / hours)
					var m = Math.floor((chaTime % hours) / minutes)
					var s = Math.floor((chaTime % minutes) / 1000)
					h = h < 10 ? '0' + h : h
					m = m < 10 ? '0' + m : m
					s = s < 10 ? '0' + s : s
					this.remainingTime = h + ':' + m + ':' + s
				} else {
					this.remainingTime = null
				}

			},
			// 获取商品详情
			getDataDetail(spid) {
				const userAgent = navigator.userAgent || navigator.vendor || window.opera;
				getCommodity({
					spid,
					userAgent
				}).then(res => {
					if (res.data.code == 200) {
						this.dataDetail = res.data.result
						this.showDetail = true
						this.xieyi(this.dataDetail.categoryId)
						document.title = res.data.result.name + ' | ' + res.data.result.introduce
						if (this.plugid) {
							if (this.plugid.indexOf("2") >= 0) {
								this.getNowTime(this.dataDetail.updateTime, this.dataDetail.countDown)
								this.thisTimes = setInterval(() => {
									this.getNowTime(this.dataDetail.updateTime, this.dataDetail.countDown)
								}, 1000)
							}
						} else {
							if (this.dataDetail.salePlug && this.dataDetail.salePlug.indexOf("2") >= 0) {
								this.getNowTime(this.dataDetail.updateTime, this.dataDetail.countDown)
								this.thisTimes = setInterval(() => {
									this.getNowTime(this.dataDetail.updateTime, this.dataDetail.countDown)
								}, 1000)
							}
						}
						// 抖音显示授权图片
						if (this.douying) {
							this.douyingAuthImg = 'https://cdn.viphk.anqingzhiyun.com/authimg/' + this.dataDetail
								.categoryId + '.png'
						}
					} else {
						this.msgVisible = true
						this.msg = res.data.message
					}
				}).catch(error => {})
			},
			// 上传图片
			beforeUpload(file, imgtext) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error('图片大小不要超过10M');
				}
				return isLt10M;
			},
			handleChange(info, imgtext) {
				let len = info.fileList.length
				if (info.file.status === 'uploading') {
					if (imgtext == 'idcardFront') {
						this.idcardFrontloading = true;
					} else if (imgtext == 'idcardBack') {
						this.idcardBackloading = true;
					} else {
						this.bustShotloading = true
					}
					return;
				}
				if (info.file.status === 'done') {
					if (info.file.response.code == 0) {
						if (imgtext == 'idcardFront') {
							this.form.idcardFront = info.fileList[len - 1].response.message
							this.idcardFrontloading = false;
						} else if (imgtext == 'idcardBack') {
							this.form.idcardBack = info.fileList[len - 1].response.message
							this.idcardBackloading = false;
						} else {
							this.form.bustShot = info.fileList[len - 1].response.message
							this.bustShotloading = false
						}
					} else {
						this.$message.error(info.file.response.message)
						if (imgtext == 'idcardFront') {
							this.idcardFrontloading = false;
						} else if (imgtext == 'idcardBack') {
							this.idcardBackloading = false;
						} else {
							this.bustShotloading = false
						}
					}
				}
			},
			// 协议
			xieyi(categoryId) {
				agreement({
					flid: categoryId
				}).then(res => {
					if (res.data.code == 200) {
						this.xieyiList = res.data.result
					}
				})
			},
			// 查看协议
			openText(title, content) {
				this.xyTitle = title
				this.xyContent = content
				this.xyVisible = true
			},
			// 关闭协议
			onClose() {
				this.xyVisible = false
			},

			// 提交信息
			submitSys() {
				if (this.isSubBtnDisabled) return
				const userAgent = navigator.userAgent || navigator.vendor || window.opera;
				// 哔哩哔哩
				if (userAgent.includes('Bili')) {
					this.form.clickPlatform = '2'
				}
				// 小红书
				if (userAgent.includes('discover')) {
					this.form.clickPlatform = '3'
				}
				var re = /^1(3|4|5|6|7|8|9)\d{9}$/
				let {
					mobile,
					consignee,
					idcard,
					address,
					idcardFront,
					idcardBack,
					bustShot
				} = this.form

				if (consignee.trim() == '') {
					this.$refs.consignee.focus()
					return this.$message.error("请输入姓名")
				}
				if (formValidation.idCardValida(idcard) != true) {
					this.$refs.idcard.focus()
					return this.$message.error(formValidation.idCardValida(idcard))
				}
				if (mobile) {
					if (!re.test(mobile)) {
						this.$refs.mobile.focus()
						return this.$message.error("请输入正确的手机号码")
					}
				} else {
					this.$refs.mobile.focus()
					return this.$message.error("请输入手机号码")
				}
				if (this.acity == "") {
					this.$refs.acity.focus()
					return this.$message.error("请选择省市区")
				}
				if (this.qu == "" || this.qu == "请选择") {
					return this.$message.error("请补充完整所在的省市区")
				}
				if (address.trim() == '') {
					this.$refs.address.focus()
					return this.$message.error("请填写详细地址")
				} else {
					// 自动去掉空格以及标点符号
					this.form.address = address.replace(/[.,!?:、，！？：【】 ]/g, '')
				}
				if (this.dataDetail.needIdcard == 1) {
					if (idcardFront == "") {
						return this.$message.error("请上传身份证正面")
					}
					if (idcardBack == "") {
						return this.$message.error("请上传身份证反面")
					}
					if (bustShot == "") {
						return this.$message.error("请上传人像面部")
					}
				}
				if (!this.agreeChecked) {
					return this.$message.error("请先勾选同意产品协议")
				}
				if (this.dataDetail.otherId) {
					this.otherCard = true
					this.cardShow = true
					getCommodity({
						spid: this.dataDetail.otherId
					}).then(res => {
						if (res.data.code == 200) {
							this.qhCardDataDetail = res.data.result
							agreement({
								flid: this.qhCardDataDetail.categoryId
							}).then(res => {
								if (res.data.code == 200) {
									this.otherXieyiList = res.data.result
								}
							})
						} else {
							this.xjOther = true
							this.othenTip = res.data.message
						}
					}).catch(error => {})
				} else {
					this.isSubBtnDisabled = true
					// 表单防重复提交
					setTimeout(() => {
						submitOrder(this.form).then(res => {
							if (res.data.code == 200) {
								this.$message.success("提交成功")
								if (this.mpSkipLink != null) {
									this.showM = true
								} else {
									this.$router.push({
										path: "/order",
										query: {
											phone: this.form.mobile,
											dlid: this.form.dlid
										}
									})
								}
							} else {
								this.isSubBtnDisabled = false
								this.$message.error(res.data.message)
							}
						}).catch(error => {})
					}, 1000)
				}
			},
			submitSys2() {
				this.isSubBtnDisabled = true
				this.form.spuId = this.dataDetail.otherId
				submitOrder(this.form).then(res => {
					if (res.data.code == 200) {
						this.cardShow = false
						this.loadingImg = true
						setTimeout(() => {
							this.loadingImg = false
							this.otherOk = true
						}, 600)
						this.isSubBtnDisabled = false
					} else {
						this.isSubBtnDisabled = false
						this.$message.error(res.data.message)
					}
				}).catch(error => {})
			},
			// 关闭切换卡
			closeOther() {
				this.otherCard = false
				this.cardShow = false
				this.otherOk = false
			},
			closeOther2() {
				this.otherCard = false
				this.cardShow = false
				this.otherOk = false
				this.$router.push({
					path: "/order",
					query: {
						phone: this.form.mobile,
						dlid: this.form.dlid
					}
				})
			}
		}
	}
</script>

<style>
	@import '../../assets/css/address.css';

	/* 直接覆盖默认样式 */
	.ant-checkbox-inner {
		border-color: #999 !important;
	}

	.ant-checkbox-checked .ant-checkbox-inner {
		background-color: #999 !important;
	}

	.ant-checkbox-checked::after {
		border-color: transparent !important;
		/* 去掉选中状态下的勾选标记边框 */
	}

	/* 固定头部 */
	.ant-drawer-header {
		position: sticky;
		top: 0;
	}

	/* 去掉全局滚动条 */
	.ant-drawer-wrapper-body {
		overflow: hidden;
	}

	/* 给内容加滚动条 */
	.ant-drawer-body {
		height: 100%;
		overflow: auto;
	}
</style>